import styled from "styled-components";

export const Btns = styled.div`
    display: inline-flex;

    .btn {
      background: #005a9e;
      color: #fff;
      margin-left: 4px;
    }
`;

export const FormContainer = styled.div`
    justify-content: space-between;
    // display:flex;
    padding: 10px;

     .form-content {
  display: flex;
      align-items: flex-end;
    }

    .form-item {
      margin-right: 40px;

      }
      .label {
         margin:  4px;
      }
`;
